export class PsUser {

    _name; // string
    _lastName; // string
    _avatar; // string
    _id; // number

    constructor(
        name,
        lastName,
        avatar,
    ) {
        this._name = name;
        this._lastName = lastName;
        this._avatar = avatar;
    }

    static fromAPIUser(user) {
        return new this(
            user.name || '',
            user.last_name || '',
            user.image || '',
            user.id || null,
        );
    }

    name() {
        return this._name;
    }

    lastName() {
        return this._lastName;
    }

    avatar() {
        return this._avatar;
    }

    completeName() {
        return `${this.name()} ${this.lastName()}`;
    }

    id() {
        return this._id;
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/shared/model/PsUser.js